// Natural size (CSS px, from the SVG files) of a deck's card pictures: the <img> reserves its place with it
// before the picture has loaded. Only the ratio counts, the shown size comes from the CSS (.the-card).
const EMPTY_SIZE = [240, 336];
const CARD_SIZES = {
    Classic: { face: [240, 336], Card: [208, 303], SUITC: [200, 214], SUITD: [200, 250], SUITH: [200, 250], SUITS: [200, 282] },
    DannyDarko: { face: [200, 300], Card: [566, 850], SUITC: [128, 128], SUITD: [128, 128], SUITH: [128, 128], SUITS: [128, 128] },
    DannyLight: { face: [200, 300], Card: [566, 850], SUITC: [128, 128], SUITD: [128, 128], SUITH: [128, 128], SUITS: [128, 128] },
    PlayingCards: { face: [223, 324], Card: [208, 303], SUITC: [200, 200], SUITD: [200, 295], SUITH: [200, 211], SUITS: [200, 240] }
};

export default {
    svg(svgImg)
    {
        const url = require("@/assets/svg/" + svgImg);
        return url;
    },    
    flag(code){
        const url = require("@/assets/svg/flags/" + code+".svg");
        return url;
    },
    card(key, deck_setting){
        deck_setting = deck_setting ?? "Classic"
        const url = require("@/assets/decks/" + deck_setting + "/" + key + ".svg");
        return url;
    },
    cardSize(key, deck_setting){
        const sizes = CARD_SIZES[deck_setting] ?? CARD_SIZES.Classic;
        const [width, height] = key === "Empty" ? EMPTY_SIZE : sizes[key] ?? sizes.face;
        return { width, height };
    }
};
